import { axios } from '../libs/axios';
import URL from '../config/url';

export default {
    newsDetail(id) {
        return axios.post(`${URL.path}/home/article/getdetail/id/${id}.html`);
    },
    newsList(params, lang) {
        let langType = 2;
        // 默认新闻 英文  俄语法语 新闻暂缺
        if (lang == 'fr') {
            langType = 4;
        }
        if (lang == 'ru') {
            langType = 3;
        }
        // position=1 列表推荐；position=2 频道推荐；position=3 首页推荐；position=7 所有位置推荐；position=0 所有，包括推荐位和非推荐位；
        return axios.get(`${URL.path}/home/article/getenlist/category/2/lang/${langType}/p/${params.pageNum || 1}?position=${params.position}`);
    }
}
